module.exports = __webpack_public_path__ + "static/img/2s-img2.f1f6f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-img2.png
// module id = HsVw
// module chunks = 0